export default {
    circles: [],
    circle: null,
}
